import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Reveal, SectionEyebrow, SectionTitle, Container } from './Primitives';
import { useLanguage } from '@/context/LanguageContext';
import { SITE } from '@/constants/testIds';

const FAQ = () => {
  const { t } = useLanguage();
  return (
    <section
      id="faq"
      data-testid={SITE.sectionFaq}
      className="relative py-20 lg:py-32 bg-[#F7F8F5]"
    >
      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <Reveal>
              <SectionEyebrow>{t.faq.eyebrow}</SectionEyebrow>
            </Reveal>
            <Reveal delay={0.05}>
              <SectionTitle className="mt-4">{t.faq.title}</SectionTitle>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <Reveal delay={0.1}>
              <Accordion type="single" collapsible className="w-full">
                {t.faq.items.map((item, i) => (
                  <AccordionItem
                    key={i}
                    value={`item-${i}`}
                    data-testid={SITE.faqItem}
                    className="bg-white border border-[rgba(0,166,81,0.1)] rounded-2xl mb-3 px-5 lg:px-6 data-[state=open]:border-[rgba(0,166,81,0.4)] data-[state=open]:shadow-[0_12px_30px_-12px_rgba(0,166,81,0.18)] transition-all"
                  >
                    <AccordionTrigger className="text-left font-['Outfit'] text-base lg:text-lg font-medium text-[#0B0F0C] hover:no-underline py-5">
                      {item.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-[#5C5C5C] leading-relaxed pb-5">
                      {item.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </Reveal>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default FAQ;
